<template>
    <button class="large-button" :class="color" :disabled="disabled">
        <slot/>
    </button>
</template>

<script>
    export default {
        name: "large_button",
        props: {
            color: {
                type: String,
                default: "blue"
            },
            disabled: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style scoped lang="scss">
    .large-button {
        height: 56px;
        width: 100%;
        border-radius: 8px;
        color: $text_white_grad;

        font-weight: bold;
        font-size: 16px;
        line-height: 19px;
        letter-spacing: 0.12em;
        text-transform: uppercase;

        &:disabled, &.disabled {
            opacity: 0.64;
            cursor: default;
            pointer-events: none;
        }

        &.blue {
            background-color: $blue;
            box-shadow: $btn_shadow_blue;
            text-shadow: $text_shadow_blue;

            &:disabled{
            }

            &:hover {
                background-color: #55BBFF;
            }
        }

        &.green {
            background-color: $green;
            box-shadow: $btn_shadow_green;
            text-shadow: $text_shadow_green;

            &:hover {
                background-color: #17D18F;
            }
        }

        &.purple {
            background-color: $purple;
            box-shadow: $btn_picto_shadow_purple;
            text-shadow: $text_shadow_purple;

            &:hover {
                background-color: #8364FF;
            }
        }

        &.gray {
            background-color: $text_gray;
            color: rgba(white, 0.5);
            box-shadow: inset -10px 10px 24px rgba(105, 118, 137, 0.72), inset 10px -8px 10px rgba(70, 76, 84, 0.84), inset 0px 0px 6px rgba(255, 255, 255, 0.16);
            text-shadow: 0 2px 4px $text_gray;
            &:hover {
                background-color: $text_gray;
            }
        }
    }
</style>
